module.exports = __webpack_public_path__ + "img/bg_intro_tunnel1.64ace054.svg";